import { NmLoader } from '../../components/NmLoader';

/** Preserve the chart footprint while using the shared loading indicator. */
export function ComparisonChartSkeleton({ height = 280 }: { height?: number }) {
  return <div style={{ height, display: 'grid', placeItems: 'center' }} aria-busy="true"><NmLoader /></div>;
}
